import { jsx as _jsx } from "react/jsx-runtime";
import { getSessionStorage } from "@jti/rest-api";
import { useSelector } from "@jti/store";
import { PaymentSummary } from "../../../../components/PaymentSummary";
import { SummaryLoyaltyPoints } from "../../../../components/SummaryLoyaltyPoints";
import { useLoyaltyStatus } from "../../../../hooks/useLoyaltyStatus";
import { useOrder } from "../../../../hooks/useOrder";
import { usePrice } from "../../../../hooks/usePrice";
const sessionStorage = getSessionStorage();
export const OrderPaymentSummary = () => {
    const { order, orderFetchStatus } = useOrder();
    const { prices } = usePrice(order, false);
    const isLoyaltyActive = useLoyaltyStatus();
    const { loyaltyChoice } = useSelector((store) => store.loyalty);
    const points = sessionStorage.get("loyaltyCartPoints", 0);
    return (_jsx(PaymentSummary, { isPricesLoading: orderFetchStatus === "pending", prices: prices, children: isLoyaltyActive ? (_jsx(SummaryLoyaltyPoints, { hasLoyalty: isLoyaltyActive, totalLoyaltyPoints: points, loyaltyChoice: loyaltyChoice || 0 })) : null }));
};
//# sourceMappingURL=OrderPaymentSummary.js.map